
export const API_BASE_URL = 'https://pathfinder-api-9nfq.onrender.com'
